<template>
  <q-btn flat color="white" class="menu-button" @click="menuLink">
    <q-icon left :name="link.icon" />
    <div class="menu-name">{{ link.name }}</div>
    <q-menu transition-show="jump-down" transition-hide="jump-up" class="header-submenu">
      <q-list>
        <q-item v-for="(item, index) in link.menu" :key="index" clickable @click="menuClick(item)">
          <q-item-section>{{ item.title }}</q-item-section>
        </q-item>
      </q-list>
    </q-menu>
  </q-btn>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import saveAs from 'file-saver';
import http from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';

interface Props {
  // 画面遷移先
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  link: any;
}
const props = defineProps<Props>();

const router = useRouter();

const emit = defineEmits(['openDialog', 'openSidebar', 'deleteSidebar']);

/**
 * 画面遷移
 */
const menuLink = () => {
  if (props.link.link) {
    emit('deleteSidebar');
    router.push({ name: props.link.link });
  }
};

// マニュアルダウンロード
const download = () => {
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('manual_type', 'admin');

  // ファイル存在チェック
  http
    .post('/ctp001001/existManualFile', formData)
    .then((response) => {
      switch (response.data.common.status) {
        // 結果ステータス：正常終了
        case ResultStatusCode.SUCCESS:
          switch (response.data.common.detail_status) {
            // 詳細結果ステータス：正常終了
            case DetailResultStatusCode.SUCCESS:
              // マニュアルダウンロード
              saveAs(response.data.path, response.data.fileName);
              break;
            // 詳細結果ステータス：正常終了（メッセージ）
            case DetailResultStatusCode.SUCCESS_MESSAGE:
              // ダイアログ表示
              emit('openDialog', true);
              break;
            default:
              break;
          }
          break;
        // 結果ステータス：異常終了
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
          break;
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// メニュークリック
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const menuClick = (item: any) => {
  if (item.name !== '') {
    // マスメンTOPに戻るときはサイドバーを閉じる
    if (item.name === 'masterTop') {
      emit('openSidebar');
    } else {
      emit('deleteSidebar');
    }
    router.push({ name: item.name, params: { type: item.type } });
  } else {
    download();
  }
};
</script>
<style scoped>
.menu-button {
  width: 160px;
  height: 100%;
  padding: 0;
}
.menu-button .q-icon {
  margin-right: 2px;
  font-size: 2.2rem;
}
.menu-button .menu-name {
  font-size: 0.8rem;
  letter-spacing: 1px;
  font-weight: 600;
  line-height: 0.9rem;
  margin-bottom: 7px;
}

.header-submenu .q-list {
  box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%),
    0 3px 1px -2px rgb(0 0 0 / 12%);
  background: var(--q-pureWhite);
  border-radius: 0;
  min-width: 180px;
}
</style>
<style>
.q-menu.header-submenu {
  border-radius: 0;
  padding: 7px 5px 5px 15px;
  box-shadow: none;
  background: none;
}

.ctp00100-header-primary .header-btn-area .menu-button .q-focus-helper {
  border-radius: 0;
  height: 50px;
  top: -7px;
}

.ctp00100-header-primary .header-btn-area .menu-button .q-ripple {
  height: 50px;
  top: -7px;
}

.ctp00100-header-primary .menu-button .q-btn__content {
  align-items: flex-end;
  padding: 0 10px;
}
</style>
